import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getRequest } from "../services";
import toast from "react-hot-toast";

const initialState = {
    examReport: null,
    sectionReports: [],
    loading: false,
    error: null,
};

export const fetchExamReport = createAsyncThunk(
    "exam/fetchExamReport",
    async (studentId, { rejectWithValue }) => {
        try {
            const response = await getRequest(`/api/Reports/GetExamReport?studentId=${studentId}`);
            console.log("API Response:", response.data);
            if (response.status !== 200) throw new Error("Failed to fetch exam report");
            return response.data;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

// Updated to use the section API endpoint directly
export const fetchSectionExamReports = createAsyncThunk(
    "exam/fetchSectionExamReports",
    async (sectionData, { rejectWithValue }) => {
        try {
            // Extract the section ID from the sectionData
            const sectionId = sectionData.id;
            
            if (!sectionId) {
                return rejectWithValue("Section ID is required");
            }
            
            // Use the new endpoint to fetch all reports at once
            const response = await getRequest(`/api/Reports/GetExamReportByClass?sectionId=${sectionId}`);
            
            if (response.status !== 200) {
                throw new Error("Failed to fetch section exam reports");
            }
            
            console.log("Section Reports API Response:", response.data);
            return response.data;
            
        } catch (error) {
            console.error("Error in fetchSectionExamReports:", error);
            return rejectWithValue(error.message || "Failed to fetch section exam reports");
        }
    }
);

const examSlice = createSlice({
    name: "exam",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchExamReport.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchExamReport.fulfilled, (state, action) => {
                state.loading = false;
                state.examReport = action.payload;
            })
            .addCase(fetchExamReport.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
                toast.error(action.payload || "Failed to fetch exam report");
            })
            .addCase(fetchSectionExamReports.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchSectionExamReports.fulfilled, (state, action) => {
                state.loading = false;
                state.sectionReports = action.payload;
            })
            .addCase(fetchSectionExamReports.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
                toast.error(action.payload || "Failed to fetch section exam reports");
            });
    },
});

export default examSlice.reducer;